var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobalLine = function SvgGlobalLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m-2.061-2.1a16.1 16.1 0 0 1-1.515-6H5.356a7.21 7.21 0 0 0 5.083 6m.288-6a14.3 14.3 0 0 0 1.773 6.077 14.3 14.3 0 0 0 1.773-6.077zm8.917 0h-3.568a16.1 16.1 0 0 1-1.515 6 7.21 7.21 0 0 0 5.083-6M5.356 11.1h3.568a16.1 16.1 0 0 1 1.515-6 7.21 7.21 0 0 0-5.083 6m5.372 0h3.544A14.3 14.3 0 0 0 12.5 5.023a14.3 14.3 0 0 0-1.773 6.077m3.833-6a16.1 16.1 0 0 1 1.515 6h3.568a7.21 7.21 0 0 0-5.083-6"
  })));
};
export default SvgGlobalLine;